import Translatable from '../translatable_text/Translatable';

function Intro() {
  return (
    <section style={{ paddingTop: '5rem', paddingBottom: '5rem' }}>
      <div className="max-w-7xl mx-auto px-4">
        {/* <div className="main-marq overflow-hidden">
          <div className="slide-har st1">
            <div className="box">
              <div className="item">
                <h4 className="flex items-center">
                  <span>Dall In</span>
                  <span className="text-5xl ml-12 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="flex items-center">
                  <span>Suport Digital Club</span>
                  <span className="text-5xl ml-12 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="flex items-center">
                  <span>Veterinary Care Card</span>
                  <span className="text-5xl ml-12 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="flex items-center">
                  <span>Anaa Jay</span>
                  <span className="text-5xl ml-12 stroke icon">*</span>
                </h4>
              </div>
            </div>
            <div className="box">
              <div className="item">
                <h4 className="flex items-center">
                  <span>Dall In</span>
                  <span className="text-5xl ml-12 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="flex items-center">
                  <span>Suport Digital Club</span>
                  <span className="text-5xl ml-12 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="flex items-center">
                  <span>Veterinary Care Card</span>
                  <span className="text-5xl ml-12 stroke icon">*</span>
                </h4>
              </div>
              <div className="item">
                <h4 className="flex items-center">
                  <span>Anaa Jay</span>
                  <span className="text-5xl ml-12 stroke icon">*</span>
                </h4>
              </div>
            </div>
          </div>
        </div> */}
        <div style={{ marginTop: '4rem'}} className="flex flex-wrap justify-between">
          <div className="w-full lg:w-1/2">
            <div className="cont">
              <h4 className="d-slideup wow">
                <span style={{ marginBottom: '4rem'}} className="sideup-text">
                  <span className="up-text">
                    <Translatable>
                      Services for service providers
                    </Translatable>
                  </span>
                </span>
              </h4>
              <div className="hidden exp mt-8 mb-4 md:mb-0 text-center md:text-left">
                <span className="text-xl opacity-70 mt-8 block">
                  <Translatable>
                    Multi Application Development
                  </Translatable>
                </span>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-5/12">
            <div className="text">
              <h5
                style={{ fontSize: '18px', lineHeight: '1.8', fontWeight: '200' }}
                className="opacity-60"
              >
                <Translatable>
                  A Saudi company working to provide services to logistics sector
                  service providers as a technical consultant through its digital lab
                </Translatable>
              </h5>
            </div>
          </div>

        </div>
      </div>
      <div className="line-overlay">
        <svg
          viewBox="0 0 1728 1101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M-43 773.821C160.86 662.526 451.312 637.01 610.111 733.104C768.91 829.197 932.595 1062.9 602.782 1098.75C272.969 1134.6 676.888 25.4306 1852 1"
            style={{ strokeDasharray: 3246.53 }}
          ></path>
        </svg>
      </div>
    </section>
  );
}

export default Intro;
